"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATES = void 0;

var _themeGet = require("@styled-system/theme-get");

var _styledComponents = require("styled-components");

var STATES = {
  default: (0, _styledComponents.css)(["height:40px;padding:0 ", ";color:", ";border-bottom:1px solid transparent;"], (0, _themeGet.themeGet)("space.2"), (0, _themeGet.themeGet)("colors.black60")),
  active: (0, _styledComponents.css)(["outline:0;color:", ";border-bottom-color:", ";&:hover{text-decoration:none !important;color:inherit !important;}"], (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.black100")),
  focus: (0, _styledComponents.css)(["text-decoration:underline;color:", ";"], (0, _themeGet.themeGet)("colors.black100")),
  hover: (0, _styledComponents.css)(["text-decoration:underline;color:", ";"], (0, _themeGet.themeGet)("colors.blue100"))
};
exports.STATES = STATES;
//# sourceMappingURL=v3.js.map